import React, { Dispatch, SetStateAction, useState } from 'react';
import {
  Button, FormGroup, Input, InputGroup, InputGroupText, Label,
} from 'reactstrap';
import Dinero from 'dinero.js';
import { useTranslation } from 'react-i18next';
import { isDefined } from '../../../utils/helpers';
import { Order } from '../../../context/OrderContext';

type DonationFormProps = {
  donationArticleId: string; defaultValue: number | undefined; setOrder: Dispatch<SetStateAction<Order>>;
};

const DonationForm = ({ donationArticleId, defaultValue, setOrder }: DonationFormProps) => {
  const [translate] = useTranslation();

  const donationAmounts = [{
    amount: 500,
  }, {
    amount: 1000,
  }, {
    amount: 2000,
  }, {
    label: translate('COMPONENTS.CHECKOUT_CONTAINER.FORM.DONATIONS.OTHER'),
    isOther: true,
  }];

  const defaultDonationAmount = donationAmounts.findIndex(({ amount }) => amount === defaultValue);
  const defaultSelectedIndex = defaultDonationAmount < 0 ? donationAmounts.length - 1 : defaultDonationAmount;
  const [selectedIndex, setSelectedIndex] = useState<number | undefined>(defaultValue
    ? defaultSelectedIndex
    : undefined);

  const setDonationAmount = (amount : number | undefined) => {
    setOrder((o) => ({
      ...o,
      quantities: {
        ...o.quantities,
        [donationArticleId]: amount || 0,
      },
    }));
  };

  return (
    <>
      <FormGroup>
        <Label>{translate('COMPONENTS.CHECKOUT_CONTAINER.FORM.DONATIONS.LABEL')}</Label>
        <div className="d-flex">
          {donationAmounts.map(({ amount, label }, i) => (
            <Button
              key={amount || label}
              color="primary"
              outline
              active={selectedIndex === i}
              onClick={() => {
                setSelectedIndex(i);
                setDonationAmount(amount);
              }}
              className="rounded-pill fw-normal"
              style={{
                fontSize: '.875rem',
                marginRight: 5,
              }}
            >
              {label || Dinero({ amount }).toFormat()}
              {selectedIndex === i && (
                <Button
                  close
                  size="sm"
                  style={{
                    fontSize: '.6rem',
                    marginLeft: 5,
                    background: 'transparent url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 '
                        + 'viewBox=%270 0 16 16%27 fill=%27%23FFF%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586'
                        + '14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1'
                        + '1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3e%3c/svg%3e") center/1em auto'
                        + 'no-repeat',
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    setSelectedIndex(undefined);
                    setDonationAmount(undefined);
                  }}
                />
              )}
            </Button>
          ))}
        </div>
      </FormGroup>

      {isDefined(selectedIndex) && donationAmounts[selectedIndex]?.isOther && (
        <FormGroup>
          <Label>{translate('COMPONENTS.CHECKOUT_CONTAINER.FORM.DONATIONS.OTHER_AMOUNT')}</Label>
          <InputGroup>
            <InputGroupText>€</InputGroupText>
            <Input
              type="number"
              defaultValue={defaultValue ? defaultValue / 100 : undefined}
              onChange={(e) => {
                setDonationAmount(Math.round(parseFloat(e.target.value) * 100));
              }}
            />
          </InputGroup>
        </FormGroup>
      )}
    </>
  );
};

export default DonationForm;
